// React
import React, { ReactElement, ReactNode } from "react";
import { UserTokenContext } from "../../Contexts/userToken";
import { UserQuestionsContext } from "../../Contexts/UserQuestionsContext";
import { SetUserQuestionContext } from "../../Contexts/SetUserQuestionContext";
import { I_AllDataNeeded, I_QuizMakerQuestions } from "../../Models/interfaces";
import { SetLessonDataContext } from "../../Contexts/SetLessonDataContext";
import { LessonDataContext } from "../../Contexts/LessonDataContext";
import {
  AllDataNeededContext,
  SetAllDataNeededContext,
} from "../../Contexts/AllDataNeededContext";
// React

const MasterWarper: React.FunctionComponent<{
  children: ReactNode | ReactElement | React.ReactNode;
  userToken: string;
  userQuestions: I_QuizMakerQuestions[];
  setUserQuestions: React.Dispatch<
    React.SetStateAction<I_QuizMakerQuestions[]>
  >;
  setLessonData: React.Dispatch<
    React.SetStateAction<{
      teacherId: number | string;
      subjectId: number | string;
      lessonId: string | number;
      lessonName: string;
    }>
  >;
  lessonData: {
    teacherId: number | string;
    subjectId: number | string;
    lessonId: string | number;
    lessonName: string;
  };

  allNeededData: I_AllDataNeeded;
  setAllNeededData: React.Dispatch<React.SetStateAction<I_AllDataNeeded>>;
}> = ({
  children,
  setUserQuestions,
  userQuestions,
  userToken,
  setLessonData,
  lessonData,
  allNeededData,
  setAllNeededData,
}) => {
  return (
    <>
      <UserTokenContext.Provider value={userToken}>
        <UserQuestionsContext.Provider value={userQuestions}>
          <SetUserQuestionContext.Provider value={setUserQuestions}>
            <SetLessonDataContext.Provider value={setLessonData}>
              <LessonDataContext.Provider value={lessonData}>
                <AllDataNeededContext.Provider value={allNeededData}>
                  <SetAllDataNeededContext.Provider value={setAllNeededData}>
                    {children}
                  </SetAllDataNeededContext.Provider>
                </AllDataNeededContext.Provider>
              </LessonDataContext.Provider>
            </SetLessonDataContext.Provider>
          </SetUserQuestionContext.Provider>
        </UserQuestionsContext.Provider>
      </UserTokenContext.Provider>
    </>
  );
};

export default MasterWarper;
